<script>
import MasterExtra from '@components/master-extra'
import { extrasPageTracking, terminateTracking } from '@src/tracking'
import { mapState } from 'vuex'

export default {
  page() {
    return {
      title: `${this.property.name} - Extras`,
      meta: [{ name: 'description', content: 'Make your stay even better' }],
    }
  },

  components: { MasterExtra },

  props: {
    property: { type: Object, required: true },
  },

  computed: {
    ...mapState('extras', {
      extras: (state) => state.all,
    }),
  },

  mounted() {
    if (process.env.NODE_ENV === 'production') {
      extrasPageTracking()
    }
  },

  beforeDestroy() {
    if (process.env.NODE_ENV === 'production') {
      terminateTracking()
    }
  },
}
</script>

<template>
  <section class="mt-6">
    <div class="container container-page mx-auto px-6">
      <div class="flex flex-wrap">
        <div class="w-full">
          <Transition name="fade" mode="out-in">
            <div v-if="extras.length" class="extras-list">
              <MasterExtra
                v-for="extra in extras"
                :key="extra.id"
                :extra="extra"
              />
            </div>

            <div v-else class="border border-gray-500 mb-6">
              <div class="py-6 px-3 text-center">
                <p class="mb-3">
                  <BaseIcon class="fa-4x" name="search" />
                </p>
                <p class="font-medium text-sm mb-3">
                  Sorry, we have no extras at this moment.
                </p>
                <BaseLink
                  class="text-sm text-blue-500 underline cursor-pointer"
                  :to="{ name: 'property-booking', query: $route.query }"
                >
                  Continue to booking form
                </BaseLink>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </div>
  </section>
</template>
